import React, { useEffect, useRef, useState } from "react";
import "./css/customer-profilemain.css";
import { Toast } from "primereact/toast";
import { useLocation } from "react-router-dom";
import { api } from "../../../../../utility/AxiosInceptor";

// -------------------- COMPONENTS --------------------
import TopBarCustomerProfile from "./Components/TopBarCustomerProfile/TopBarCustomerProfile";
import { CustomerProfileInfo } from "./Components/CutomerProfile/Customer-Profile";
import { CustomerLineInfoMain } from "./Components/LineInfo/LineInfoMain";
import { OtherInfoCustomerProfileMain } from "./Components/OtherInfo/Otherinfo";
import { NotesCommonCustomerProfile } from "./Components/CommonComponent/Notes/MainNotesCustomerProfile";
import { PaymentMain } from "./Components/Payments/PaymentMain";
import { QuickLinkMain } from "./Components/QuickLinks/QuickLinksMain";
import { CustomerUsage } from "./Components/Usage/UsageMain";
import { MainCustomerFile } from "./Components/Files/Files";
import { Wallet } from "./Components/Wallet/Wallet";
import { ChildAccountMain } from "./Components/ChildAccounts/ChildAccountMain";
import AllCustomers from "./All-Customers/AllCustomers";

// ================================================================
// MainCustomerProfile Component
// ================================================================
export const MainCustomerProfile = ({
  setRefreshOnNotification,
  refreshOnNotification,
  refreshEsn,
  model,
  setRefreshEsn,
  refreshNotificationcomponent,
}) => {
  // -------------------- STATE --------------------
  const [cpData, setCpData] = useState([]); // Customer profile data
  const location = useLocation();
  const initialSelectedId =
    location?.state?.selectedId ??
    JSON.parse(localStorage.getItem("selectedId"));
  const [selectedId, setSelectedId] = useState(initialSelectedId);
  const [changeCustomerStatusDialog, setChangeCustomerStatus] = useState(false); // Status dialog open/close
  const [currentSelectedTab, setCurrentSelectedTab] =
    useState("customer-profile"); // Active tab
  const [serviceInfoApiCalled, setServiceInfoApiCalled] = useState(false); // To call ServiceInfo API only once
  const [planData, setPlanData] = useState(); // Customer plan data
  const [showAllCustomers, setShowAllCustomers] = useState(true); // Switch between all-customers view and profile view
  const [refreshCustomerData, setRefreshCustomerData] = useState(false); // Trigger refresh

  // -------------------- REFS --------------------
  const toast = useRef(null);

  // -------------------- HELPERS --------------------
  // Fetch customer profile data
  const getCustomerProfileData = async () => {
    // Read selectedId once (avoid parsing multiple times)
    const selectedId = JSON.parse(localStorage.getItem("selectedId"));
    if (!selectedId) {
      setCpData({});
      return;
    }

    // Helper: fetch user details
    const fetchUserDetails = async () => {
      try {
        const res = await api.get(`/api/user/userDetails?userId=${selectedId}`);
        return res?.status === 200 || res?.status === 201
          ? res.data.data
          : null;
      } catch {
        return null;
      }
    };

    // Helper: fetch tracking number
    const fetchTrackingNumber = async () => {
      try {
        const res = await api.get(
          `/api/web/order/getTrackingNumber/?customerId=${selectedId}`
        );
        return res?.status === 200 || res?.status === 201
          ? res.data.data
          : null;
      } catch {
        return null;
      }
    };

    // Helper: fetch paid service info
    const fetchServiceInfo = async (res2) => {
      if (!res2?.esn && !res2?.phoneNumber) return;
      try {
        const res = await api.post(`/api/user/serviceInfo`, {
          enrollmentId: res2._id,
          mdn: res2.phoneNumber,
          esn: res2.esn,
        });
        setPlanData(res?.data?.data);
      } catch {
        // ignore errors
      }
    };

    // ------------------- MAIN FLOW -------------------
    if (!serviceInfoApiCalled) {
      const res2 = await fetchUserDetails();

      if (res2) {
        const trackingNumber = await fetchTrackingNumber();
        setCpData(trackingNumber ? { ...res2, trackingNumber } : res2 || []);

        await fetchServiceInfo(res2);
        setServiceInfoApiCalled(true);
      } else {
        setCpData({});
        setServiceInfoApiCalled(true);
      }
    } else {
      // Refresh user details if API already called
      const res2 = await fetchUserDetails();
      setCpData(res2 || {});
    }
  };

  // -------------------- EFFECTS --------------------
  // Refresh customer profile on notification or when triggered
  useEffect(() => {
    if (!showAllCustomers) {
      if (refreshOnNotification !== "") {
        setServiceInfoApiCalled(false);
        setCurrentSelectedTab("customer-profile");
        setSelectedId(refreshOnNotification);
      }
      getCustomerProfileData();
    }
    return () => {
      setRefreshOnNotification("");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCustomerData, showAllCustomers, refreshOnNotification]);

  // On mount → Check if selectedId exists in localStorage
  useEffect(() => {
    if (localStorage.getItem("selectedId")) {
      setShowAllCustomers(false);
    } else {
      setShowAllCustomers(true);
    }
    return () => {
      localStorage.removeItem("selectedId");
    };
  }, []);

  // Show customer profile if triggered from notifications
  useEffect(() => {
    if (refreshOnNotification !== "") {
      setShowAllCustomers(false);
    }
  }, [refreshOnNotification]);

  // -------------------- UI --------------------
  return (
    <>
      {/* All Customers view OR Customer Profile view */}
      {showAllCustomers || !localStorage.getItem("selectedId") ? (
        // All Customers screen
        <AllCustomers
          setRefreshCustomerData={setRefreshCustomerData}
          setShowAllCustomers={setShowAllCustomers}
        />
      ) : (
        // Customer Profile screen
        <div className="customer-profile-main-container">
          {/* TopBar with tabs + actions */}
          <TopBarCustomerProfile
            setServiceInfoApiCalled={setServiceInfoApiCalled}
            refreshNotificationcomponent={refreshNotificationcomponent}
            refreshEsn={refreshEsn}
            setCurrentSelectedTab={setCurrentSelectedTab}
            currentSelectedTab={currentSelectedTab}
            setChangeCustomerStatus={setChangeCustomerStatus}
            changeCustomerStatusDialog={changeCustomerStatusDialog}
            setRefreshEsn={setRefreshEsn}
            setSelectedId={setSelectedId}
            cpData={cpData}
            model={model}
            setRefreshCustomerData={setRefreshCustomerData}
            selectedId={selectedId}
            isServiceInfoApiCalled={serviceInfoApiCalled}
          />

          {/* Tabs rendering */}
          {currentSelectedTab === "customer-profile" ||
          currentSelectedTab === "line-info" ||
          currentSelectedTab === "other-info" ? (
            <div
              className={`${
                currentSelectedTab === "line-info"
                  ? "line-info-main"
                  : currentSelectedTab === "customer-profile"
                    ? "customer-profile-main-info"
                    : currentSelectedTab === "other-info"
                      ? "other-info-main"
                      : ""
              }`}
            >
              {currentSelectedTab === "customer-profile" ? (
                <CustomerProfileInfo
                  setRefreshCustomerData={setRefreshCustomerData}
                  cpData={cpData}
                />
              ) : currentSelectedTab === "line-info" ? (
                <CustomerLineInfoMain
                  isServiceInfoApiCalled={serviceInfoApiCalled}
                  planData={planData}
                  cpData={cpData}
                />
              ) : currentSelectedTab === "other-info" ? (
                <OtherInfoCustomerProfileMain cpData={cpData} />
              ) : undefined}

              {/* Common Notes Section */}
              <div className="SideoneNotes">
                <NotesCommonCustomerProfile cpData={cpData} />
              </div>
            </div>
          ) : currentSelectedTab === "payment" ? (
            <PaymentMain
              setRefreshCustomerData={setRefreshCustomerData}
              cpData={cpData}
            />
          ) : currentSelectedTab === "quick-links" ? (
            <QuickLinkMain cpData={cpData} />
          ) : currentSelectedTab === "usage" ? (
            <CustomerUsage cpData={cpData} />
          ) : currentSelectedTab === "files" ? (
            <MainCustomerFile cpData={cpData} />
          ) : currentSelectedTab === "wallet" ? (
            <Wallet
              setRefreshCustomerData={setRefreshCustomerData}
              cpData={cpData}
            />
          ) : currentSelectedTab === "child-accounts" ? (
            <ChildAccountMain
              setServiceInfoApiCalled={setServiceInfoApiCalled}
              setRefreshOnNotification={setRefreshOnNotification}
              setCurrentSelectedTab={setCurrentSelectedTab}
              setSelectedId={setSelectedId}
              setRefreshCustomerData={setRefreshCustomerData}
              cpData={cpData}
            />
          ) : undefined}
        </div>
      )}
      {/* Toast for notifications */}
      <Toast ref={toast} />
    </>
  );
};
